import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import ProviderInvitationInformationCard from "./ProviderInvitationInformationCard";
import { LangContext } from "../LangContext.jsx";
class InvitationPerson extends Component {
    static contextType = LangContext; 
    constructor(props) {
        super();
        this.state = {
            invitation:{
                status:''
            },
            documents:[]
        };
        this.resendInvitation = this.resendInvitation.bind(this)
    }

    componentDidMount() {
        this.getInvitation() 
    }

    async getInvitation(){
        const res = await axios.get('/api/invitations/' + this.props.invitation_id);
        this.setState({invitation: res.data})
        this.setState({
            documents: res.data.dossier.documents.concat(res.data.additional_documents)
        });
    }

    async resendInvitation() {
        const { lang } = this.context; 
        window.blockUI();
        await axios.put(
            '/api/invitations/' + this.props.invitation_id + '/forwarding',
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            KTUtil.btnRelease(KTUtil.getById('btnSubmit'));
            swal.fire({
                text: lang.get('messages.invitacion_reenviada'),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            });
        }).catch((error) => {
            const message = getErrorsMessage(error);
            KTUtil.btnRelease(KTUtil.getById('btnSubmit'));
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        }).then(() => {
            window.unblockUI();
        });;
    }

    confirmDelete = ()=>{
        const { lang } = this.context; 
        swal.fire({
            text: lang.get('messages.estas_seguro_que_deseas_eliminar_esta_invitacion'),
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText: lang.get('messages.continuar'),
            cancelButtonText: lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.deleteInvitation();
            }
        });
    }

    deleteInvitation = () => {
        window.blockUI();
        axios.delete(
            '/api/persons/invitation/' + this.props.invitation_id,
            {},
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            window.location.href = '/';
        })
        .catch((error) => {
            window.unblockUI();
            swal.fire({
                text: 'Algo salió mal, intenta de nuevo',
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        });
    }

    render() {
        const { lang } = this.context; 
        const canResendInvitation = this.props.permissions?.providers?.includes('all') || this.props.permissions?.providers?.includes('resend_invitation');
        const canDeleteInvitations = this.props.permissions?.providers?.includes('all') || this.props.permissions?.providers?.includes('delete_invitations');
        const canShowInvitationActions = this.props.usermode == 'provider' || canResendInvitation || canDeleteInvitations;

        return (<div className="container">
            <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                <div className="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap w-100">
                    <ProviderInvitationInformationCard invitation_id={this.props.invitation_id} />
                    <div className="text-center align-items-center flex-wrap col-2">
                        <span className="text-dark font-weight-bold">Estatus</span><br/>
                        {this.state.invitation?.status == 'Declinado' ?
                            <span className={'badge badge-'+this.state.invitation?.status.toString().toLowerCase()}>Declinado</span>
                            :
                            <span className={'badge badge-'+this.state.invitation?.status.toString().toLowerCase()}>{ this.state.invitation?.status }</span>
                        }
                    </div>
                    <div className="d-flex align-items-center flex-wrap">
                        {canShowInvitationActions &&
                            <div className="dropdown dropdown-inline">
                                <a href="#" className="btn btn-fixed-height btn-primary font-weight-bolder font-size-sm px-5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {lang.get('messages.acciones')}
                                    &nbsp;&nbsp;
                                    <i className="flaticon2-down icon-sm"></i>
                                </a>
                                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 m-0 rounded-lg" style={{ background: '#F0E9FF' }}>
                                <ul className="navi navi-hover"> 
                                    {this.props.usermode == 'provider' && 
                                        <li className="navi-item">
                                            <a href={'/persons/invitations/'+this.props.invitation_id+'/accept'}  className="navi-link py-4"  >
                                                <span className="navi-icon mr-5 text-center">
                                                        <span className="flaticon-interface-5 text-primary icon-md"></span>
                                                </span>
                                                <span className="navi-text text-secondary">{lang.get('messages.aceptar_invitacion')}</span>
                                                <span className="navi-icon pull-right">
                                                    <button className="btn btn-icon btn-light btn-xs bg-white">
                                                        <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                    </button>
                                                </span>
                                            </a>
                                            <a href={'/persons/invitations/'+this.props.invitation_id+'/refuse'}  className="navi-link py-4"  >
                                                <span className="navi-icon mr-5 text-center">
                                                        <span className="flaticon2-cross text-primary icon-md"></span>
                                                </span>
                                                <span className="navi-text text-secondary">{lang.get('messages.rechazar_invitacion')}</span>
                                                <span className="navi-icon pull-right">
                                                    <button className="btn btn-icon btn-light btn-xs bg-white">
                                                        <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                    </button>
                                                </span>
                                            </a>
                                        </li>
                                    } 
                                    {this.props.usermode == 'client' && 
                                    <>
                                        {canResendInvitation && (
                                        <li className="navi-item">
                                            <span role="button" onClick={() => this.resendInvitation()}  className="navi-link py-4 cursor">
                                                <span className="navi-icon mr-5 text-center">
                                                    <span className="flaticon2-mail text-primary icon-md"></span>
                                                </span>
                                                <span className="navi-text text-secondary">{lang.get('messages.reenviar_invitacion')}</span>
                                                <span className="navi-icon pull-right">
                                                    <button className="btn btn-icon btn-light btn-xs bg-white">
                                                        <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                    </button>
                                                </span>
                                            </span>
                                        </li>
                                        )}
                                        {canDeleteInvitations && (
                                        <li className="navi-item">
                                            <span role="button" onClick={()=>{ this.confirmDelete() }}  className="navi-link py-4 cursor">
                                                <span className="navi-icon mr-5 text-center">
                                                    <span className="flaticon-delete fw-normal text-primary icon-md"></span>
                                                </span>
                                                <span className="navi-text text-secondary">{lang.get('messages.borrar_invitacion')}</span>
                                                <span className="navi-icon pull-right">
                                                    <button className="btn btn-icon btn-light btn-xs bg-white">
                                                        <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                    </button>
                                                </span>
                                            </span>
                                        </li>
                                        )}
                                        </>
                                        } 
                                    </ul>
                                </div>
                            </div>
                        } 
                    </div>
                </div>
            </div>
            <div className="p-15 card card-custom d-block" id="kt_subheader">
                <div className="mb-10">
                    {lang.get('messages.listado_de_documentos_del_expediente')} <span className="text-success"></span>
                </div>
                { this.state.documents?.map((d, i) => {
                    return <div key={i} className="mb-2 font-weight-bolder">
                        <i className="flaticon2-check-mark text-primary mr-4" style={{"fontSize": "0.80rem"}}></i>
                        { d.title }
                    </div>
                })}
            </div> 
        </div>);
    }
}

export default InvitationPerson;

if (document.getElementById('InvitationPerson')) {
    ReactDOM.render(<InvitationPerson />, document.getElementById('InvitationPerson'));
}
